// PluginContract_ClauseNode.ts
export const ClauseNodeContract = {
  pluginName: 'ClausePlugin',
  nodeTypes: ['ClauseNode'],
  register: (editor: any) => {
    editor.registerNodeType?.('ClauseNode');
    console.log('🔌 [ClausePlugin] Registered ClauseNode');
  },
};